/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { RangeControl, SelectControl, TextControl, ToggleControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import blockConst from '../constants';

const { hookPrefix } = blockConst;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { initialOpenFirst, initialOpenAll, hasAccordion } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'faqs',
						initialOpen: true,
						label: () => {
							return __( 'Faqs' );
						},
						cb: () => {
							return <>
								<ToggleControl label={ __( 'Accordion' ) } checked={ hasAccordion } onChange={ () => {
									setAttributes( {
										hasAccordion: ! hasAccordion,
									} );
								} }
								/>
								<ToggleControl label={ __( 'Open All FAQs' ) } checked={ initialOpenAll } onChange={ () => {
									setAttributes( {
										initialOpenAll: ! initialOpenAll,
									} );

									updateInnerBlocks( ! initialOpenAll, initialOpenFirst );
								} }
								/>
								{ ! initialOpenAll && <ToggleControl label={ __( 'Open first FAQ' ) } checked={ initialOpenFirst } onChange={ () => {
									setAttributes( {
										initialOpenFirst: ! initialOpenFirst,
									} );
									updateInnerBlocks( initialOpenAll, ! initialOpenFirst );
								} } /> }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
